import { Entities, EntityKind } from "../state/entityKinds";
import { autoTile4bit_self_check_some, hasKind_some_test } from "./autotiler";
import { BOARD_SIZE, layerDepthDiff } from "../constants";

export function attachStaticWall(
  scene: Phaser.Scene,
  entity: Entities,
  board: Entities[][],
  seededRandom: Phaser.Math.RandomDataGenerator
) {
  const { x, y } = entity;
  let index =
    autoTile4bit_self_check_some(
      board,
      x,
      y,
      (e_pred) => e_pred.kind === EntityKind.StaticWall
    ) + 1;
  if (
    (index === 11 || index === 12) &&
    !hasKind_some_test(
      board,
      x - 1,
      y + 1,
      (e_pred) => e_pred.kind === EntityKind.StaticWall
    )
  ) {
    index = 17;
  }
  if (
    (index === 13 || index === 14) &&
    !hasKind_some_test(
      board,
      x + 1,
      y + 1,
      (e_pred) => e_pred.kind === EntityKind.StaticWall
    )
  ) {
    index = 18;
  }
  const sprite = scene.add.sprite(
    x * BOARD_SIZE,
    y * BOARD_SIZE,
    "atlas",
    getWallSpriteName(seededRandom, index)
  );
  sprite.setDepth(y + layerDepthDiff.WALLS);
  // if (index === 16) {
  //   const color = Phaser.Display.Color.HSLToColor(
  //     0,
  //     0,
  //     seededRandom.weightedPick([1, 0.95, 0.97, 0.94, 0.9, 0.7])
  //   );
  //   sprite.setTint(color.color32);
  // }
}

function getWallSpriteName(
  seededRandom: Phaser.Math.RandomDataGenerator,
  idx: number
) {
  if ([2, 4, 6, 8, 10, 12, 14, 16].includes(idx)) {
    idx -= 1;
  }
  let spriteName = `SolidWalls/SolidWall${idx}`;
  if ([1, 3, 5, 7, 9, 11, 13, 15, 17, 18].includes(idx)) {
    spriteName += `-${seededRandom.integerInRange(1, 4)}`;
  }
  return spriteName;
}
